const PAGE_VIEW_DEDUPE_KEY = "__flashquote_last_tracked_page";

function getGtag() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return null;
  }

  return window.gtag;
}

export function isAnalyticsReady() {
  return Boolean(getGtag()) && Boolean(window.GA_MEASUREMENT_ID);
}

export function trackPageView(path) {
  const gtag = getGtag();

  if (!gtag || !path) {
    return;
  }

  const previousPath = window[PAGE_VIEW_DEDUPE_KEY];
  if (previousPath === path) {
    return;
  }

  window[PAGE_VIEW_DEDUPE_KEY] = path;

  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(eventName, params = {}) {
  const gtag = getGtag();

  if (!gtag || !eventName) {
    return;
  }

  gtag("event", eventName, params);
}
